import { render, staticRenderFns } from "./DevisTypesBARTH.vue?vue&type=template&id=d374add0&scoped=true"
import script from "./DevisTypesBARTH.vue?vue&type=script&lang=js"
export * from "./DevisTypesBARTH.vue?vue&type=script&lang=js"
import style0 from "./DevisTypesBARTH.vue?vue&type=style&index=0&id=d374add0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d374add0",
  null
  
)

export default component.exports